import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DetailResult from "../../subtabs/WMTransactionDetailSubTab";
import WMAptmmtsTab from "../../subtabs/WMAptmmtsTab";
import TransactionStagingAssignTab from "../../subtabs/TransactionStagingAssignTab";
import TransactionTransportTab from "../../subtabs/TransactionTransportTab";
import WMSerialNumberNoHeaderInfoTab from "../../subtabs/WMSerialNumberNoHeaderInfoTab";
import ChargesDetailTab from "../../subtabs/ChargesDetailTab";
import HistoryTransaction from "../../subtabs/HistoryTransaction";
import CustomerSubTab from "../../subtabs/CustomerSubTab";
import ItemSubTab from "../../subtabs/ItemSubTab";
import LocationSubTab from "../../subtabs/LocationSubTab";
import AllTransactionsSubTab from "../../subtabs/AllTransactionsSubTab";
import CaretsDetailSubTab from "../../subtabs/CaretsDetailSubTab";
import LaborTrackingSubTab from "../../subtabs/LaborTrackingSubTab";
import {
    GetCustomerGridGridData
} from "../../../../../../om/services/SalesOrderService";

const TransactionInfoSubTab = forwardRef((props, ref) => {
    const orderDetailTab = 1;
    const aptmmtsTab = 2;
    const stagingAssignTab = 3;
    const transportTab = 4;
    const serialNumberTab = 5;
    const chargesTab = 6;
    const histTransTab = 7;
    const custTransTab = 8;
    const itemTab = 9;
    const locationTab = 10;
    const allTransTab = 11;
    const openTransTab = 12;
    const caretDetailTab = 13;
    const laborTrackingTab = 14;
    const getLaborTrackingDetailUrl = "wm/TransactionManagement/GetLaborTrackingDetails";
    const getcaretDetailUrl = "wm/TransactionManagement/GetCrateDetails";
    const getOrderDetailSearchUrl = "wm/TransactionManagement/GetTransactionDetail";
    const getAptmmtsUrl = "wm/TransactionManagement/GetTransactionAptmmtsDetail";
    const GetstagingAssignUrl = "wm/TransactionManagement/GetTransactionStagingAssignDetail";;
    const transportUrl = "wm/TransactionManagement/GetTransactionTransportDetail";
    const serialNumberUrl = "wm/TransactionManagement/GetTransactionSerialNumberNoDetail";
    const chargesUrl = "wm/TransactionManagement/GetChargesDetail";
    const [orderDetailDataSource, setOrderDetailDataSource] = useState(null);
    const [aptmmtsDataSource, setAptmmtsDataSource] = useState(null);
    const [stagingAssignDataSource, setStagingAssignDataSource] = useState(null);
    const [transportDataSource, setTransportDataSource] = useState(null);
    const [serialNumbertDataSource, setserialNumbertDataSource] = useState(null);
    const [chargesDataSource, setchargesDataSource] = useState(null);
    const [selectedRow, setSelectedRow] = useState([]);
    const [activeTab, setActiveTab] = useState(orderDetailTab);
    const [dataSource, setDataSource] = useState(null);
    const getDataUrl = "wm/TransactionManagement/GetTransactionHeader";
    const transactionTypeAll = 'A';
    const commited = 1;
    const all=2;
    const open=0;
    const initialItemFormFields = {
        R_CUSTOMER: '',
        itemCode: '',
        itemDescription1: '',
        customerName: '',
    };
    const [ItemformFields, setItemformFields] = useState(initialItemFormFields);
    const GetLocationsUrl = "wm/TransactionManagement/GetLocationsByCustomer";
    const initialLocationFormFields = {
        Warehouse: '',
        Location: '',
        Description: '',
        Classcode: '',
    };
    const [LocationformFields, setLocationformFields] = useState(initialLocationFormFields);
    const GetItemGridData = (accessToken, url, formFields) => {
        const resultData = createStore({
            key: 'rowId',
            loadParams:
            {
                Transactiontype: function () {
                    return 'Z';
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    const GetGridData = (accessToken, url, formFields, type,status) => {
        const resultData = createStore({
            key: 'rowid',
            loadParams:
            {
                Recordtype: function () {
                    return 'R';
                },
                Transactiontype: function () {
                    return type;
                },transStatus: function () {
                    return status;
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    const searchData = (type,status) => {
        var resultData = GetGridData(props.accessToken, getDataUrl, null, type,status);
        setDataSource(resultData);
    };
    const getCustomerListUrl = "om/SaleOrder/GetCustomerList";
    const GetAllItemsDataUrl = "wm/TransactionManagement/GetItemsByCustomer";
    const initialFormFields = {
        R_CUSTOMER: '',
        Name: '',
        Address1: '',
        Address2: '',
        City: '',
        State: '',
        Zip: '',
        Tel: '',

    };
    const [formFields, setformFields] = useState(initialFormFields);
    const searchcustData = (formFields) => {
        var resultData = GetCustomerGridGridData(props.accessToken, getCustomerListUrl, formFields);
        setDataSource(resultData);
    };
    const searchItemData = (formfeilds, url) => {
        var resultData = GetItemGridData(props.accessToken, url, formfeilds);
        setDataSource(resultData);
    };
    const GetCrateDetailsGridData = (accessToken, url, headerId) => {
        const resultData = createStore({
            key: 'rowid',
            loadParams:
            {
                headerId: function () {
                    return headerId;
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    const GetOrderDetailGridData = (accessToken, url, headerId) => {
        const resultData = createStore({
            key: 'rowid',
            loadParams:
            {
                headerId: function () {
                    return headerId;
                },
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/${url}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        return resultData;
    };
    useImperativeHandle(ref, () => ({
        updateData(data) {
            setSelectedRow(data);
        }
    }));

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex);
    };
    const LoadTabsData = () => {
        if (selectedRow && selectedRow?.rowid  && activeTab === orderDetailTab) {
            var resultData = GetOrderDetailGridData(props.accessToken, getOrderDetailSearchUrl, selectedRow.rowid);
            setOrderDetailDataSource(resultData);
        }
        else if (activeTab === aptmmtsTab) {
            var resultData = GetOrderDetailGridData(props.accessToken, getAptmmtsUrl, selectedRow.rowid);
            setAptmmtsDataSource(resultData);
        }
        else if (activeTab === stagingAssignTab) {
            var resultData = GetOrderDetailGridData(props.accessToken, GetstagingAssignUrl, selectedRow.rowid);
            setStagingAssignDataSource(resultData);
        }
        else if (activeTab === transportTab) {
            var resultData = GetOrderDetailGridData(props.accessToken, transportUrl, selectedRow.rowid);
            setTransportDataSource(resultData);
        }
        else if (selectedRow && selectedRow?.rowid  && activeTab === serialNumberTab) {
            var resultData = GetOrderDetailGridData(props.accessToken, serialNumberUrl, selectedRow.rowid);
            setserialNumbertDataSource(resultData);
        }
        else if (selectedRow && selectedRow?.rowid && activeTab === chargesTab) {
            var resultData = GetOrderDetailGridData(props.accessToken, chargesUrl, selectedRow.rowid);
            setchargesDataSource(resultData);
        }
        else if (activeTab === histTransTab) {
            searchData(transactionTypeAll,commited);
        }
        else if (activeTab === custTransTab) {
            searchcustData(formFields);
        }
        else if (activeTab === itemTab) {
            searchItemData(ItemformFields, GetAllItemsDataUrl);
        }
        else if (activeTab === locationTab) {
            searchItemData(LocationformFields, GetLocationsUrl);
        }
        else if (activeTab === allTransTab) {
            searchData(transactionTypeAll,all);
        }
        else if (activeTab === openTransTab) {
            searchData(transactionTypeAll,open);
        }
        else if (selectedRow && selectedRow?.rowid && activeTab === caretDetailTab) {
            var resultData = GetCrateDetailsGridData(props.accessToken, getcaretDetailUrl, selectedRow.rowid);
            setOrderDetailDataSource(resultData);
        }
        else if (selectedRow && selectedRow?.rowid && activeTab === laborTrackingTab) {
            var resultData = GetOrderDetailGridData(props.accessToken, getLaborTrackingDetailUrl, selectedRow.rowid);
            setOrderDetailDataSource(resultData);
        }



    }
    useEffect(() => {
        LoadTabsData();
    }, [selectedRow, activeTab]);
    return (
        <div style={{marginTop:'8px', height: '100%', display: 'flex', flexDirection: 'column', overflow: 'hidden', minHeight: 0}}>
            <div className="tab-bar" style={{ flexShrink: 0 }}>
                <div
                    className={`tab ${activeTab === orderDetailTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(orderDetailTab)}
                >
                    Detail
                </div>
                <div
                    className={`tab ${activeTab === aptmmtsTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(aptmmtsTab)}
                >
                    Pln/Aptmmts
                </div>
                <div
                    className={`tab ${activeTab === stagingAssignTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(stagingAssignTab)}
                >
                    Staging/Assign
                </div>
                <div
                    className={`tab ${activeTab === transportTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(transportTab)}
                >
                    Transport
                </div>
                <div
                    className={`tab ${activeTab === serialNumberTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(serialNumberTab)}
                >
                    Serial#
                </div>
                <div
                    className={`tab ${activeTab === chargesTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(chargesTab)}
                >
                    Charges
                </div>
                <div
                    className={`tab ${activeTab === histTransTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(histTransTab)}
                >
                    Hist/Trans
                </div>
                <div
                    className={`tab ${activeTab === custTransTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(custTransTab)}
                >
                    Customers
                </div>
                <div
                    className={`tab ${activeTab === itemTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(itemTab)}
                >
                    Items
                </div>
                <div
                    className={`tab ${activeTab === locationTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(locationTab)}
                >
                    Locations
                </div>
                <div
                    className={`tab ${activeTab === allTransTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(allTransTab)}
                >
                    All-Trans
                </div>
                <div
                    className={`tab ${activeTab === openTransTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(openTransTab)}
                >
                    Open-Trans
                </div>
                <div
                    className={`tab ${activeTab === caretDetailTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(caretDetailTab)}
                >
                    Crates Details
                </div>
                <div
                    className={`tab ${activeTab === laborTrackingTab ? 'active' : ''}`}
                    onClick={() => handleTabClick(laborTrackingTab)}
                >
                    Labor Track
                </div>
            </div>
            <div style={{ flex: 1, minHeight: 0, overflow: 'hidden', paddingBottom: '1px' }}>
            {activeTab === orderDetailTab && (
                <DetailResult data={orderDetailDataSource} />
            )}
            {activeTab === aptmmtsTab && (
                <WMAptmmtsTab data={aptmmtsDataSource} />
            )}
            {activeTab === stagingAssignTab && (
                <TransactionStagingAssignTab data={stagingAssignDataSource} />
            )}
            {activeTab === transportTab && (
                <TransactionTransportTab data={transportDataSource} />
            )}
            {activeTab === serialNumberTab && (
                <WMSerialNumberNoHeaderInfoTab data={serialNumbertDataSource} />
            )}
            {activeTab === chargesTab && (
                <ChargesDetailTab data={chargesDataSource} />
            )}
            {activeTab === histTransTab && (
                <HistoryTransaction data={dataSource} />
            )}
            {activeTab === custTransTab && (
                <CustomerSubTab data={dataSource} />
            )}
            {activeTab === itemTab && (
                <ItemSubTab data={dataSource} />
            )}
            {activeTab === locationTab && (
                <LocationSubTab data={dataSource} />
            )}
            {activeTab === allTransTab && (
                <AllTransactionsSubTab data={dataSource} />
            )}
             {activeTab === openTransTab && (
                <AllTransactionsSubTab data={dataSource} />
            )}
             {activeTab === caretDetailTab && (
                <CaretsDetailSubTab data={orderDetailDataSource} />
            )}
             {activeTab === laborTrackingTab && (
                <LaborTrackingSubTab data={orderDetailDataSource} />
            )}
            </div>
        </div>
    );
});

export default TransactionInfoSubTab;